import * as R from "ramda";

import {
  FETCH_OPPORTUNITIES,
  FETCH_NOTIFICATIONS
} from "../actions/opportunities";
import { SELECT_COMPANY } from "../actions/company";
import {
  CREATE_OPPORTUNITY,
  CREATE_AND_PUBLISH_OPPORTUNITY,
  CLONE_OPPORTUNITY,
  SAVE_OPPORTUNITY_DETAILS,
  PUBLISH_OPPORTUNITY,
  SAVE_OPPORTUNITY_MEDIA,
  UNPUBLISH_OPPORTUNITY
} from "../actions/opportunity";

const initialState = {
  list: null,
  notifications: []
};

const opportunities = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_OPPORTUNITIES.RESOLVED:
      return { ...state, list: payload };

    case CLONE_OPPORTUNITY.RESOLVED:
    case CREATE_AND_PUBLISH_OPPORTUNITY.RESOLVED:
    case CREATE_OPPORTUNITY.RESOLVED:
      return R.evolve({
        list: R.append(payload)
      })(state);

    case FETCH_NOTIFICATIONS.RESOLVED:
      return { ...state, notifications: payload };
    case UNPUBLISH_OPPORTUNITY.RESOLVED:
    case PUBLISH_OPPORTUNITY.RESOLVED:
    case SAVE_OPPORTUNITY_MEDIA.RESOLVED:
    case SAVE_OPPORTUNITY_DETAILS.RESOLVED:
      if (!payload) return state;

      return {
        ...state,
        list: state.list.map(opportunity =>
          opportunity.id === payload.id ? payload : opportunity
        )
      };
    case SELECT_COMPANY.TYPE:
      return initialState;

    default:
      return state;
  }
};

export default opportunities;
